<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							New Account
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="inputName" class="col-form-label">Name <span class="text-danger">*</span></label>
									<input type="text" v-model="accountRequest.name" @blur="validationRule()" class="form-control" id="inputName">
									<small class="text-danger">{{validationData.name}}</small>
								</div>
								<div class="col-md-6">
									<label for="inputEmail" class="col-form-label">Email <span class="text-danger">*</span></label>
									<input type="text" v-model="accountRequest.email" @blur="validationRule()" class="form-control" id="inputEmail">
									<small class="text-danger">{{validationData.email}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="inputRole" class="col-form-label">Role <span class="text-danger">*</span></label>
									<select v-model="accountRequest.role" @blur="validationRule()" class="form-control" id="inputRole">
										<option value="">Select Role</option>
										<option value="super-admin">Super Admin</option>
										<option value="admin">Admin</option>
										<option value="finance">Finance</option>
										<option value="staff">Staff</option>
									</select>
									<small class="text-danger">{{validationData.role}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="inputPassword" class="col-form-label">Password <span class="text-danger">*</span></label>
									<input type="password" v-model="accountRequest.password" @blur="validationRule()" class="form-control" id="inputPassword">
									<small class="text-danger">{{validationData.password}}</small>
								</div>
								<div class="col-md-6">
									<label for="inputRePassword" class="col-form-label">Re-Password <span class="text-danger">*</span></label>
									<input type="password" v-model="accountRequest.rePassword" @blur="validationRule()" class="form-control" id="inputRePassword">
									<small class="text-danger">{{validationData.rePassword}}</small>
								</div>
							</div>
							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'accountCreate',
		metaInfo: {
            title: "Account Create",
            titleTemplate: "%s ← MIC",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				message: "",
				accountRequest: {
					name: "",
					email: "",
					role: "",
					password: "",
					rePassword: ""
				},
				validationData: {
					name: "",
					email: "",
					role: "",
					password: "",
					rePassword: ""
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				accountStoreAction: 'accountStoreAction',
			}),
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('name', this.accountRequest.name);
				formData.append('email', this.accountRequest.email);
				formData.append('role', this.accountRequest.role);
				formData.append('password', this.accountRequest.password);
				formData.append('confirmed', this.accountRequest.rePassword);

				await this.accountStoreAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: 'account-list', 
					query: {
						page: 1, 
						per_page: 20, 
						sort_direction: 'desc', 
						sort_by: 'created_at',
						search: '',
						email: '',
						role: ''
					}
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.accountRequest.name == "") {
					this.validationData.name = "The name field is required."
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.accountRequest.email == "") {
					this.validationData.email = "The email field is required."
					isValidation.push(true)
				} else {
					this.validationData.email = ""
					isValidation.push(false)
				}
				if (this.accountRequest.role == "") {
					this.validationData.role = "The role field is required."
					isValidation.push(true)
				} else {
					this.validationData.role = ""
					isValidation.push(false)
				}
				if (this.accountRequest.password == "") {
					this.validationData.password = "The password field is required."
					isValidation.push(true)
				} else {
					this.validationData.password = ""
					isValidation.push(false)
				}
				if (this.accountRequest.rePassword == "") {
					this.validationData.rePassword = "The re-password field is required."
					isValidation.push(true)
				} else {
					this.validationData.rePassword = ""
					isValidation.push(false)
				}
				if (this.accountRequest.password !== this.accountRequest.rePassword) {
					this.validationData.rePassword = "The password and re-password fields must match."
					isValidation.push(true)
				}
				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>